import axios from "axios";
import { PROCESS_AUTOMATION_SERVICE_URL } from "../Common/Constant/API";
import { commonRequestHeaders } from "../Common/request/headers";

export const createUser = async (newUser) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.post(
            `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/user-management/create`,
            newUser,
            {
                headers: {
                    ...commonRequestHeaders(),
                    Authorization: `Bearer ${token}`,

                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error during creating new user:", error);
        throw error;
    }
};

export const fetchUsers = async () => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.get(
            `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/user-management/users`,
            {
                headers: {
                    ...commonRequestHeaders(),
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        console.log(response.data);
        return response.data;
    } catch (error) {
        console.error("Error fetching Users:", error);
        throw error;
    }
};

export const updateUserRoles = async (userId, updatedRoles) => {
    if (!userId) throw new Error("updatedRoles: userId is required");
    if (!Array.isArray(updatedRoles)) throw new Error("updatedRoles: roles must be an array");

    const token = localStorage.getItem("token");

    const res = await axios.post(
        `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/user-management/${encodeURIComponent(userId)}/update-roles`,
        updatedRoles, // <-- array in JSON body
        {
            headers: {
                ...commonRequestHeaders(),
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        }
    );

    return typeof res.data === "undefined" ? null : res.data;
};

export const updateUser = async (userId, UpdatedUser) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.patch(
            `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/user-management/${encodeURIComponent(userId)}`,
            UpdatedUser,
            {
                headers: {
                    ...commonRequestHeaders(),
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error during update user:", error);
        throw error;
    }
};

export const deleteUser = async (userId) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.delete(
            `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/user-management/${encodeURIComponent(userId)}`,
            {
                headers: {
                    ...commonRequestHeaders(),
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error during delete user:", error);
        throw error;
    }
};

export const addTenantsToUser = async (userId, updatedTenants) => {
    if (!userId) throw new Error("addTenantsToUser: userId is required");
    if (!Array.isArray(updatedTenants)) throw new Error("addTenantsToUser: tenants must be an array");

    const token = localStorage.getItem("token");

    const res = await axios.post(
        `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/user-management/${encodeURIComponent(userId)}/tenants`,
        updatedTenants,
        {
            headers: {
                ...commonRequestHeaders(),
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        }
    );

    return typeof res.data === "undefined" ? null : res.data;
};

export const removeTenantFromUser = async (userId, removedTenants) => {
    console.log("Removing tenants", removedTenants, "from user", userId);
    if (!userId) throw new Error("removeTenantFromUser: userId is required");
    if (!Array.isArray(removedTenants)) throw new Error("removeTenantFromUser: tenants must be an array");

    const token = localStorage.getItem("token");

    const res = await axios.delete(
        `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/user-management/${encodeURIComponent(userId)}/tenants`,
        {
            data: removedTenants,
            headers: {
                ...commonRequestHeaders(),
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        }
    );

    return typeof res.data === "undefined" ? null : res.data;
};

export const fetchUserTenants = async (userId) => {
    if (!userId) throw new Error("fetchUserTenants: userId is required");

    const token = localStorage.getItem("token");

    const res = await axios.get(
        `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/user-management/${encodeURIComponent(userId)}/tenants`,
        {
            headers: {
                ...commonRequestHeaders(),
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        }
    );

    return typeof res.data === "undefined" ? null : res.data;
};
